import { overrideStyle } from 'sdk/messages/creators';

import { sendMessage } from '.';

export const sendOverrideStyle = () => (dispatch: any) => {
    dispatch(sendMessage(overrideStyle()));
};
